import { Layout } from 'antd';
import { styled } from 'styled-components';

const PageStyled = styled(Layout)`
    background: var(--fill-fill-3, #E5E5E5);
    height:100vh;
`;

export default PageStyled;
